var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.imageCount && _vm.imageCount > 0)?_c('span',{attrs:{"title":_vm.imageCount + ' ' + _vm.$gettext('images')}},[_c('icon-image')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }